import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";
import { IAppModel } from "@/model";

/**
 * 通讯服务类
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class SmsService extends ServiceBase {

    /**
     * 发送短信
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async sendSms(data: any): Promise<IHttpResponse> {
        let response = await this.apis.sendSms({ data });
        return response;
    }

}